import { useEffect, useState } from "react";
import axios from "axios";
import { API } from "@/App";
import { apiErrorMessage } from "@/components/EmailTemplateRecipients";

// A function, not a constant: `API` is not yet initialised while this file loads
// (App.js imports it — circular import).
const previewUrl = () => `${API}/notification-config/admin/client-announcement/preview`;
const DEBOUNCE_MS = 250;

/**
 * Live preview from the backend: the exact HTML the email will carry (one renderer
 * for preview and send). Debounced; a newer request aborts the older one, and the
 * last good preview stays on screen while the next one loads.
 */
export default function useAnnouncementPreview(body) {
  const key = body ? JSON.stringify(body) : null;
  const [state, setState] = useState({ data: null, loading: false, error: null });

  useEffect(() => {
    if (!key) return undefined;
    const controller = new AbortController();
    setState((s) => ({ ...s, loading: true }));
    const timer = setTimeout(async () => {
      try {
        const { data } = await axios.post(previewUrl(), JSON.parse(key), { signal: controller.signal });
        setState({ data, loading: false, error: null });
      } catch (err) {
        if (axios.isCancel(err)) return;
        setState((s) => ({ ...s, loading: false, error: apiErrorMessage(err, "The preview could not be generated") }));
      }
    }, DEBOUNCE_MS);
    return () => { clearTimeout(timer); controller.abort(); };
  }, [key]);

  return state;
}
